import { authFetch } from "utils";

export const get = (spaceIDs) =>
  authFetch(`${apiUrl}${version}/spaces/?space_ids=${spaceIDs}`, {
    method: "GET",
  });

export const getByAsset = (assetID) =>
  authFetch(`${apiUrl}${version}/assets/${assetID}/spaces`, {
    method: "GET",
  });

export const remove = (spaceID) =>
  authFetch(`${apiUrl}${version}/spaces/${spaceID}`, {
    method: "DELETE",
  });

export const create = (space) =>
  authFetch(`${apiUrl}${version}/spaces`, {
    method: "POST",
    json: { space: { ...space, pricesAttributes: space.prices } },
  });

export const update = (space) =>
  authFetch(`${apiUrl}${version}/spaces/${space.id}`, {
    method: "PUT",
    json: { space: { ...space, pricesAttributes: space.prices } },
  });
